export function getToken(): string {
  return localStorage.getItem('access_token') || localStorage.getItem('token') || '';
}

export function authHeaders(): Record<string, string> {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    Authorization: token ? 'Bearer ' + token : '',
  };
}

export function money(n: number | string | undefined | null): string {
  const v = Number(n) || 0;
  return '$' + v.toLocaleString('en-CA', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function toggleFilter<T>(
  filters: T,
  setFilters: (next: T) => void,
  key: keyof T,
  value: string,
): void {
  const current = (filters as any)[key] as string[];
  const next = current.includes(value)
    ? current.filter((v) => v !== value)
    : [...current, value];
  setFilters({ ...filters, [key]: next });
}